import React from 'react';
import './SearchAndSortBar.css';

const SearchAndSortBar = ({ searchQuery, onSearchChange }) => {
  return (
    <div className="search-sort-bar">
      <div className="search-container">
        <span className="search-icon">🔍</span>
        <input
          type="text"
          className="search-input"
          placeholder="Search menu items..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>
    </div>
  );
};

export default SearchAndSortBar;

